module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-300.woff?a7622f60c56ddd5301549a786b54e6e6";